import { render, staticRenderFns } from "./PicTypeDefine.vue?vue&type=template&id=606c5684&scoped=true"
import script from "./PicTypeDefine.vue?vue&type=script&lang=js"
export * from "./PicTypeDefine.vue?vue&type=script&lang=js"
import style0 from "./PicTypeDefine.vue?vue&type=style&index=0&id=606c5684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c5684",
  null
  
)

export default component.exports